export default __webpack_public_path__ + "static/mainProject1-d50ef4226e59b1a2aea1f17a5ca3e288.png";